module.exports = "<div class=\"header-class\">\n{{header}}\n</div>"